import Link from 'next/link'
import { useRouter } from 'next/router'

import { H4, Text } from '../../../../styles/typography'
import { AboutEl } from '../elements'
import CourseHomeStore from '../stores/course-home-store'

const About = () => {
  const {
    query: { livdemyId },
  } = useRouter()

  const {
    data: { name, artist, coHosts = [] },
  } = CourseHomeStore.useContainer()

  return (
    <AboutEl>
      <H4>{name}</H4>
      <Link href={`/${livdemyId}`}>
        <a>
          <Text>
            By <span>{artist}</span>
            {Boolean(coHosts.length) && ' ft. '}
            <span className='co-hosts'>
              {coHosts.map((coHost, i) => (
                <Link
                  key={coHost.livdemyId}
                  href={`/${coHost.livdemyId}`}
                  passHref
                >
                  <a>
                    <span className='artist'>
                      {coHost.name}
                      {i !== coHosts.length - 1 ? ', ' : ' '}
                    </span>
                  </a>
                </Link>
              ))}
            </span>
          </Text>
        </a>
      </Link>
    </AboutEl>
  )
}

export default About
